import { Range } from "react-range";
import React, { Fragment } from "react";
import StarFull from "../../assets/vectors/StarFull";
import StarEmpty from "../../assets/vectors/StarEmpty";

const CustomRange = ({ setSearchParams, searchParams, fields, reset }) => {
	const valuesToUse = fields.map(
		(field) => parseFloat(searchParams?.[field]) || 1,
	);

	return (
		<div className="range-container">
			<Range
				step={0.1}
				min={1}
				max={5}
				values={valuesToUse}
				onChange={(values) => {
					setSearchParams((prev) => {
						const newObj = { ...prev };
						// Remove reset fields
						reset.forEach((key) => delete newObj[key]);

						// Set new values
						fields.forEach((key, index) => {
							const val = values[index];
							if (val != null) newObj[key] = val.toString();
						});

						return newObj;
					});
				}}
				renderTrack={({ props, children }) => (
					<div
						{...props}
						className="range-track"
						style={{
							...props.style,
						}}>
						{children}
					</div>
				)}
				renderThumb={({ props }) => {
					const { key, ...rest } = props;

					return key === 1 ? (
						<div className="range-thumb" key={"range-thumb-full-" + key} {...rest}>
							<StarFull>
								<>{props?.["aria-valuenow"]}</>
							</StarFull>
						</div>
					) : (
						<div className="range-thumb" key={"range-thumb--empty" + key} {...rest}>
							<StarEmpty>
								<>{props?.["aria-valuenow"]}</>
							</StarEmpty>
						</div>
					);
				}}
			/>
		</div>
	);
};

export default CustomRange;
